import SectionCard from "@/appComponents/Blocks/Composites/SectionCard/SectionCard";
import { appstr } from "@coreapp/utils/appstr";
import { Divider, Flex, Text } from "@theorgchartdev/storybook";
import { useEffect } from "react";
import { FieldMappingRow } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/FieldMappingRow";
import {
  GetPromotedPositionEmployeeFieldGroups,
  GetRequiredFields,
  initializeFieldFormats
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/Utils";
import { SynthesizePositions } from "@coreapp/utils/SynthesizePositions";
import {
  kDesiredHolders,
  kParentPositionID,
  kPositionID,
  kStaffingTarget,
  SYSTEM_CALCULATE
} from "@coreapp/constants";

export const PositionMappingSection = ({
  localConfig,
  BuildFieldMappingOptions,
  disableDropdowns,
  handleFieldRename,
  handleCustomFieldNameValidation,
  onUpdate
}) => {
  const requiredFields = GetRequiredFields(localConfig);
  const fieldGroups = GetPromotedPositionEmployeeFieldGroups(localConfig);
  const { posFieldGroup, empFieldGroup } = fieldGroups || { posFieldGroup: {}, empFieldGroup: {} };

  const synthesizePositions = SynthesizePositions(localConfig);

  const internallyGenerated = synthesizePositions ? [kPositionID, kParentPositionID] : [];

  // Initialize number formatting for Desired Holders field
  useEffect(() => {
    if (onUpdate && posFieldGroup && localConfig.fields) {
      // Get the mapped field name for "Desired Holders"
      const desiredHoldersMappedName = localConfig.fields[kDesiredHolders];
      const numberFields = [];

      if (
        desiredHoldersMappedName &&
        desiredHoldersMappedName !== SYSTEM_CALCULATE &&
        desiredHoldersMappedName !== ""
      ) {
        numberFields.push(desiredHoldersMappedName);
      } else {
        numberFields.push(kStaffingTarget);
      }

      if (numberFields.length > 0) {
        initializeFieldFormats(numberFields, localConfig, onUpdate, "number");
      }
    }
  }, [localConfig]);

  return (
    <SectionCard title={appstr("General field mapping")}>
      <Flex direction={"column"} gap={"24px"}>
        <Flex direction={"column"} gap={"16px"}>
          <Text size="medium" modifier={"bold"}>
            {appstr("Employee fields")}
          </Text>
          {empFieldGroup &&
            Object.keys(empFieldGroup).map(key => (
              <FieldMappingRow
                key={key}
                fieldKey={key}
                fieldValue={localConfig.fields ? localConfig.fields[key] : null}
                localConfig={localConfig}
                BuildFieldMappingOptions={BuildFieldMappingOptions}
                disabled={disableDropdowns}
                handleFieldRename={handleFieldRename}
                handleCustomFieldNameValidation={handleCustomFieldNameValidation}
                required={
                  requiredFields &&
                  (Array.isArray(requiredFields)
                    ? requiredFields.includes(key)
                    : Object.keys(requiredFields).includes(key))
                }
                onUpdate={onUpdate}
              />
            ))}
        </Flex>
        <Divider />
        <Flex direction={"column"} gap={"16px"}>
          <Text size="medium" modifier={"bold"}>
            {appstr("Position fields")}
          </Text>
          {posFieldGroup &&
            Object.keys(posFieldGroup).map(key => (
              <FieldMappingRow
                key={key}
                fieldKey={key}
                fieldValue={
                  internallyGenerated.includes(key)
                    ? appstr("System generated item", { item: appstr(key) })
                    : (localConfig?.fields?.[key] ?? null)
                }
                localConfig={localConfig}
                BuildFieldMappingOptions={BuildFieldMappingOptions}
                disabled={disableDropdowns || internallyGenerated.includes(key)}
                handleFieldRename={handleFieldRename}
                handleCustomFieldNameValidation={handleCustomFieldNameValidation}
                required={
                  requiredFields &&
                  (Array.isArray(requiredFields)
                    ? requiredFields.includes(key)
                    : Object.keys(requiredFields).includes(key))
                }
                tooltipProps={
                  internallyGenerated.includes(key)
                    ? {
                        message: appstr("System generated positions"),
                        position: "right"
                      }
                    : undefined
                }
                onUpdate={onUpdate}
              />
            ))}
        </Flex>
      </Flex>
    </SectionCard>
  );
};
